import FilterInstance from '@/models/filters/filterInstance';

class DatePickerFilter extends FilterInstance {
    constructor (params) {
        super({
            ...params,
            type: 'DatePicker'
        });
    }
}

export default DatePickerFilter;
